const initialState = {
  collapsed: false,
  navTheme: 'dark',
  isMobile: false,
  navBarHeight: 75, // TODO: review it, css or less can be easy to handle
};

export default function ThemeReducer(state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR_COLLAPSED':
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case 'SET_MOBILE':
      return {
        ...state,
        isMobile: action.payload,
      };

    default:
      return state;
  }
};
